/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

/** 
  All of the routes for the Vision UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Vision UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import DubaiAI from "layouts/dubai-ai";
import RestrictedZoneMonitor from "layouts/restricted-zone-monitor";
import PPEDetectionDashboard from "layouts/ppe-detection-dashboard";
import LostAndFound from "layouts/lost-and-found";
import TheftDetection from "layouts/theft-detection";
import FireDetection from "layouts/fire-detection";
import DocumentArchiving from "layouts/document-archiving";
import FallDetection from "layouts/fall-detection";
import AIInventoryAgent from "layouts/ai-inventory-agent";
import Attendance from "layouts/attendance";
import UserSubmissionForm from "layouts/user-submission-form";
import UserSubmissions from "layouts/user-submissions";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// Vision UI Dashboard React icons
import { IoRocketSharp } from "react-icons/io5";
import { IoIosDocument } from "react-icons/io";
import { BsFillPersonFill } from "react-icons/bs";
import { IoBuild } from "react-icons/io5";
import { BsCreditCardFill } from "react-icons/bs";
import { IoStatsChart } from "react-icons/io5";
import { IoHome } from "react-icons/io5";
import { IoSparkles } from "react-icons/io5";
import { IoWarning } from "react-icons/io5";
import { IoShieldCheckmark } from "react-icons/io5";
import { IoSearch } from "react-icons/io5";
import { IoVideocam } from "react-icons/io5";
import { IoFlame } from "react-icons/io5";
import { IoDocumentText } from "react-icons/io5";
import { IoPersonOutline } from "react-icons/io5";
import { IoPeopleOutline } from "react-icons/io5";
import { IoAddCircleOutline } from "react-icons/io5";
import { IoCube } from "react-icons/io5";
import { IoCalendar } from "react-icons/io5";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <IoHome size="15px" color="inherit" />,
    component: Dashboard,
    noCollapse: true,
  },
  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   route: "/tables",
  //   icon: <IoStatsChart size="15px" color="inherit" />,
  //   component: Tables,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   route: "/billing",
  //   icon: <BsCreditCardFill size="15px" color="inherit" />,
  //   component: Billing,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   route: "/rtl",
  //   icon: <IoBuild size="15px" color="inherit" />,
  //   component: RTL,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Dubai AI",
    key: "dubai-ai",
    route: "/dubai-ai",
    icon: <IoSparkles size="15px" color="inherit" />,
    component: DubaiAI,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Restricted Zone Monitor",
    key: "restricted-zone-monitor",
    route: "/restricted-zone-monitor",
    icon: <IoWarning size="15px" color="inherit" />,
    component: RestrictedZoneMonitor,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "PPE Detection Dashboard",
    key: "ppe-detection-dashboard",
    route: "/ppe-detection-dashboard",
    icon: <IoShieldCheckmark size="15px" color="inherit" />,
    component: PPEDetectionDashboard,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Lost and Found",
    key: "lost-and-found",
    route: "/lost-and-found",
    icon: <IoSearch size="15px" color="inherit" />,
    component: LostAndFound,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Theft Detection",
    key: "theft-detection",
    route: "/theft-detection",
    icon: <IoVideocam size="15px" color="inherit" />,
    component: TheftDetection,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Fire Detection",
    key: "fire-detection",
    route: "/fire-detection",
    icon: <IoFlame size="15px" color="inherit" />,
    component: FireDetection,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Document Archiving",
    key: "document-archiving",
    route: "/document-archiving",
    icon: <IoDocumentText size="15px" color="inherit" />,
    component: DocumentArchiving,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Fall Detection",
    key: "fall-detection",
    route: "/fall-detection",
    icon: <IoPersonOutline size="15px" color="inherit" />,
    component: FallDetection,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "AI Inventory Agent",
    key: "ai-inventory-agent",
    route: "/ai-inventory-agent",
    icon: <IoCube size="15px" color="inherit" />,
    component: AIInventoryAgent,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Attendance",
    key: "attendance",
    route: "/attendance",
    icon: <IoCalendar size="15px" color="inherit" />,
    component: Attendance,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "User Registration",
    key: "user-submission-form",
    route: "/user-submission-form",
    icon: <IoAddCircleOutline size="15px" color="inherit" />,
    component: UserSubmissionForm,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Registration Form",
    key: "form",
    route: "/form",
    icon: <IoAddCircleOutline size="15px" color="inherit" />,
    component: UserSubmissionForm,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "View Our Users",
    key: "user-submissions",
    route: "/user-submissions",
    icon: <IoPeopleOutline size="15px" color="inherit" />,
    component: UserSubmissions,
    noCollapse: true,
  },
  // { type: "title", title: "Account Pages", key: "account-pages" },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   route: "/profile",
  //   icon: <BsFillPersonFill size="15px" color="inherit" />,
  //   component: Profile,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign In",
  //   key: "sign-in",
  //   route: "/authentication/sign-in",
  //   icon: <IoIosDocument size="15px" color="inherit" />,
  //   component: SignIn,
  //   noCollapse: true,
  // },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   route: "/authentication/sign-up",
  //   icon: <IoRocketSharp size="15px" color="inherit" />,
  //   component: SignUp,
  //   noCollapse: true,
  // },
];

export default routes;
